import { render, staticRenderFns } from "./footerBot.vue?vue&type=template&id=429b5147&"
import script from "./footerBot.vue?vue&type=script&lang=js&"
export * from "./footerBot.vue?vue&type=script&lang=js&"
import style0 from "./footerBot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports